<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="权限名" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item ref="code" label="唯一编码" name="code">
      <a-input v-model:value="formState.code" placeholder="不能超过30个字符" />
    </a-form-item>

    <a-form-item label="类型" name="type">
      <a-radio-group v-model:value="formState.type">
        <a-radio-button :value="0">目录</a-radio-button>
        <a-radio-button :value="1">菜单</a-radio-button>
        <a-radio-button :value="2">权限</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="路由" name="route" v-if="formState.type !=0">
      <a-input v-model:value="formState.route" placeholder="对应页面的路径" />
    </a-form-item>
    <a-form-item label="状态" name="status">
      <a-radio-group v-model:value="formState.status">
        <a-radio-button :value="1">启用</a-radio-button>
        <a-radio-button :value="0">禁用</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="图标" name="icon">
      <a-input v-model:value="formState.icon" placeholder="对应页面的路径" />
    </a-form-item>
    <a-form-item label="备注" name="remark">
      <a-input
        v-model:value="formState.remark"
        placeholder="不能超过80个文字"
      />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits } from 'vue'
  import { message } from 'ant-design-vue'
  import { createPerm, updatePerm } from '@/api/system_manage/perm'

  const props = defineProps({ isEdit: Boolean, editData: Object, data: Array })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        ...props.editData,
        permissionId: props.editData.permission_id,
        pid: props.editData.pid || 0,
      }
    : {
        pid: props.editData?.permission_id || 0,
        name: '',
        code: '',
        remark: '',
        route: '',
        status: '',
        type: '',
        icon: '',
      }
  const formState = reactive(defaultFormState)
  const rules = {
    name: [
      {
        required: true,
        message: '请输入权限名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true,
        message: '请输入唯一编码',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个字符',
        trigger: 'blur',
      },
      {
        pattern: /^[0-9a-zA-Z:_]+$/,
        message: '仅限阿拉伯数字、英文字母',
        trigger: 'change',
      },
    ],
    type: [
      {
        required: true,
        message: '请选择类型',
        trigger: 'blur',
      },
    ],
    status: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'blur',
      },
    ],
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updatePerm : createPerm
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn(data)
    if (res.success) {
      message.success(messageText + '权限成功！')
      emit('submit')
    } else {
      message.warn(messageText + '权限错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建权限错误：', error)
      })
  }
</script>
